import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import type { Database } from "@copro/api";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { useAuth } from "../../../hooks/useAuth";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

type PostCommand = Omit<Database['public']['Tables']['topics']['Insert'], 'user_id' | 'space_id'> & {
  user_id?: string;
  space_id?: string;
};

async function postTopic(command: PostCommand, userId: string | undefined, spaceId: string) {
  if (!userId) {
    throw new Error('Utilisateur non authentifié.')
  }

  const { data, error } = await apiClient
    .from('topics')
    .insert({ ...command, user_id: userId, space_id: spaceId })
    .select()
    .single();

  if (error) {
    throw error
  }

  return data;
}

export function usePostTopic() {
  const { user } = useAuth();
  const { currentSpace } = useSpace();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (command: PostCommand) => postTopic(command, user?.id, currentSpace!.id),
    onSuccess: () => {
      enqueueSnackbar('Sujet créé.', 'success');

      queryClient.invalidateQueries({ queryKey: keys.topicListArchivedOrNot(false) })
      queryClient.invalidateQueries({ queryKey: keys.topicListPagedAll() })
    }
  })
}
